"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = useBreakpoint;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const react_1 = require("react");
const index_1 = require("../utils/index");
const use_debounce_1 = require("use-debounce");
const Css_1 = require("../Css");
/**
 * A React hook to return a record of responsive breakpoints that updates on resize.
 *
 * @example
 * const breakpoints = useBreakpoint();
 * if (breakpoints.mdAndDown) { ...do something cool }
 */
function useBreakpoint() {
    const [breakpoints, setBreakpoints] = (0, react_1.useState)(matchMediaBreakpoints());
    const handleResize = (0, use_debounce_1.useDebouncedCallback)(() => {
        const newBps = matchMediaBreakpoints();
        if ((0, fast_deep_equal_1.default)(breakpoints, newBps))
            return;
        setBreakpoints(newBps);
    }, 250);
    (0, react_1.useEffect)(() => {
        window.addEventListener("resize", handleResize);
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, [handleResize]);
    return breakpoints;
}
function matchMediaBreakpoints() {
    const bps = {};
    (0, index_1.safeEntries)(Css_1.Breakpoints).forEach(([name, bp]) => {
        bps[name] = window.matchMedia(bp.replace("@media ", "")).matches;
    });
    return bps;
}
